import * as React from 'react';
import { StickyContainer } from '@components/StickyContainer/StickyContainer';
import { PhoneFrame } from '@components/PhoneFrame/PhoneFrame';
import { Wrapper, StickyContent, phoneScale } from './StickyPhone.s';
import { phoneFrameSizes } from '@components/PhoneFrame/PhoneFrame';
import clamp = require('lodash/clamp');

type StickyPhoneProps = {
  start: number;
  end: number;
  windowHeight: number;
};

export const StickyPhone = (props: StickyPhoneProps) => (
  <Wrapper>
    <StickyContainer start={props.start} end={props.end} margin={400} windowHeight={props.windowHeight}>
      {({ position, start, end, max }) => {
        const followStart = props.windowHeight - position;
        const followEnd = max - position + props.windowHeight;
        const stop = props.windowHeight / 2;
        const top = clamp(stop, followStart, followEnd);
        const topOffset = top - followStart;
        const contentScrollHeight = max / phoneScale + phoneFrameSizes.contentHeight;
        const totalMargin = contentScrollHeight - phoneFrameSizes.contentHeight * 3;
        const contentMargin = totalMargin / 3;
        const contentTranslateFollow = -(topOffset / phoneScale);
        const contentTranslateFollowAbs = Math.abs(contentTranslateFollow);
        const fixFirstMargin = contentTranslateFollowAbs > 0 ? Math.min(contentTranslateFollowAbs, contentMargin) : 0;
        const secondMarginLimit = phoneFrameSizes.contentHeight + contentMargin;
        const fixSecondMargin =
          contentTranslateFollowAbs > secondMarginLimit
            ? Math.min(contentTranslateFollowAbs - secondMarginLimit, contentMargin)
            : 0;
        const thirdMarginLimit = secondMarginLimit * 2;
        const fixThirdMargin =
          contentTranslateFollowAbs > thirdMarginLimit
            ? Math.min(contentTranslateFollowAbs - thirdMarginLimit, contentMargin)
            : 0;
        const contentTranslate = contentTranslateFollow + fixFirstMargin + fixSecondMargin + fixThirdMargin;
        return (
          <StickyContent style={{ transform: `translateY(${top}px) translate(-50%, -50%)` }}>
            <PhoneFrame scale={phoneScale}>
              <div style={{ transform: `translateY(${contentTranslate}px)` }}>
                <div style={{ height: phoneFrameSizes.contentHeight }}>
                  <video loop={true} muted={true} autoPlay={true} style={{ width: '100%', height: '100%' }}>
                    <source src={require('./medias/02_quizz.mp4')} />
                    <img src={require('./medias/placeholderQuizz.jpg')} style={{ width: '100%', height: '100%' }} />
                  </video>
                </div>
                <div style={{ height: phoneFrameSizes.contentHeight }}>
                  <video loop={true} muted={true} autoPlay={true} style={{ width: '100%', height: '100%' }}>
                    <source src={require('./medias/03_liste.mp4')} />
                    <img src={require('./medias/placeholderListe.jpg')} style={{ width: '100%', height: '100%' }} />
                  </video>
                </div>
                <div style={{ height: phoneFrameSizes.contentHeight }}>
                  <video loop={true} muted={true} autoPlay={true} style={{ width: '100%', height: '100%' }}>
                    <source src={require('./medias/04_amis.mp4')} />
                    <img src={require('./medias/placeholderAmis.jpg')} style={{ width: '100%', height: '100%' }} />
                  </video>
                </div>
              </div>
            </PhoneFrame>
          </StickyContent>
        );
      }}
    </StickyContainer>
  </Wrapper>
);



// WEBPACK FOOTER //
// src/app/src/components/StickyPhone/StickyPhone.tsx